import { QueryClientProvider } from '@tanstack/react-query';
import { ReactQueryDevtools } from '@tanstack/react-query-devtools';
import { RouterProvider } from "react-router-dom";
import { reactQueryClient } from '~/shared/contexts/CommonAppContext';
import router from '../routes/music-app-routes';

declare global {
  interface Window {
    landlogic_app: {
      config: {
        site_id: number,
        server_env: {
          stripe_mode: 'live' | 'test',
        }
      },
      constants: {
        images: {
          thumbnails: string[]
        }
      }
    }
  }
}

const MusicApp = () => {
  console.log('hi world');
  return (
    <QueryClientProvider client={reactQueryClient} >
      <RouterProvider router={router} />

      <ReactQueryDevtools initialIsOpen={false} />
    </QueryClientProvider>
  )
}

export default MusicApp;